import React, {Fragment } from 'react';
import Heading from 'components/heading/heading';
import FormGeneralInfo from 'blocks/form-general-info/form-general-info'
import IconInfoGeneral from '../../assets/svg/icon-info-general.svg';

const ModalGeneralInfo = ({ modalProps }) => {
    return (
        <Fragment>
            <Heading text="General Info" icon={IconInfoGeneral} scaleIcons />
            <FormGeneralInfo/>
        </Fragment>
    )
};

export default ModalGeneralInfo;
